<template>
  <div>
    <banner-description
      title="covid19.generalInformation"
      titleColor="#1687A7"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }"
      :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconSeaBlueLeft', imgFormat: 'svg', position: 'top: 0%' }"
      :imgObj="{ componentName: 'covid19', imgName: 'generalInformation', imgFormat: 'svg' }"
      class="pb-16"
    />

    <collapse-group :descriptionList="covid19Store.generalInformationList" labelColor="#1687A7" />
  </div>
</template>

<script setup lang="ts">
import { useCovid19Store } from "@/stores/covid19";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const covid19Store = useCovid19Store();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>

<style scoped>
</style>